export default __webpack_public_path__ + "static/media/body_background.23b6fbc7.png";